import {priority} from '@priority-software/priority-proto-api/lib';
import {isRTLString} from '@priority-software/priority-utils/lib/strings';

export function isLtrStyle(value: string = '', type: priority.netitems.form.ColumnType): boolean {
    let isLtrStyle = true;
    if ((type === priority.netitems.form.ColumnType.Rstr && !value.length) || isRTLString(value)) {
        isLtrStyle = false;
    }
    return isLtrStyle;
}
